import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "@effect/platform";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { Authorization } from "../auth/middleware";
import { MeResponse } from "../models/me";

export const MeGroup = HttpApiGroup.make("me")
  .add(
    HttpApiEndpoint.get("getMe", "/me")
      .middleware(Authorization)
      .addSuccess(MeResponse)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
